import makeApiCall from "./master/axiosIndex";

export const workApprovalApis = {
  fetchWorkApprovals: (params: {
    projectIds: string | string[];
    approvalStatus: "Pending" | "Approved";
    [key: string]: any;
  }): Promise<any> =>
    makeApiCall({
      url: "/state-approvals/list",
      method: "get",
      params: {
        ...params
      },
    }),
  approveWorkItem: (data: {
    projectId: number;
    data: Array<{
      approvalLinkId: string;
      parentModule: string;
    }>;
    reason?: string;
  }): Promise<any> =>
    makeApiCall({
      url: "/state-approvals/approveModule",
      method: "patch",
      data,
    }),
  rejectWorkItem: (data: {
    projectId: number;
    data: Array<{
      approvalLinkId: string;
      parentModule: string;
    }>;
    reason: string;
  }): Promise<any> =>
    makeApiCall({
      url: "/state-approvals/rejectModule",
      method: "patch",
      data,
    }),


  // New API for approving a state module wise
  approveState: (data: {
    stateApprovalId: number;
    // reason?: string;
  }): Promise<any> =>
    makeApiCall({
      url: "/state-approvals/approveState",
      method: "put",
      data,
    }),

  rejectState: (data: {
    stateApprovalId: number;
    reason: string;
  }): Promise<any> =>
    makeApiCall({
      url: "/state-approvals/rejectState",
      method: "put",
      data,
    }),
};